/**
 * Zipcode lookup File
 * @param var countryCode , Zipcode and retail-sessionID 
 * @returns  api url & payload 
 * @author - TERRA
 */


let countryISOCode = 'us',
    langCode = (CookieService.getCookie('WULanguageCookie_') || 'EN').toLowerCase(),
    domainName = location.host,
    purchaserZipCodeElement = document.querySelector('form#rmo-form input[id="purchaserZip"]'),
    purchasedZipCodeElement = document.querySelector('form#rmo-form input[id="purchasedZip"]');


/**
 * fetch createSessionMethod
 * @returns promise object
 */
const invokeDigitalSession = () => {
    return createSessionMethod(countryISOCode, langCode, domainName);
}
/**
 * fetch createRetailSessionMethod
 * @returns promise object
 */
const invokeRetailSession = (sessionID) => {
    return createRetailSessionMethod(countryISOCode, langCode, domainName, sessionID);
}
/**
 * fetch ZipCodeApiLookUpMethod
 * @returns promise object
 */
const invokeZipcodeLookUp = (retailSessionID, ZipCode) => {
    return ZipCodeApiLookUpMethod(countryISOCode, domainName, retailSessionID, ZipCode);
}

/**
 * toggleInlineAutoLoader -   toggle the inline loader
 * @param {*} targetID 
 * @param {*} action 
 */

const toggleInlineAutoLoader = (targetID, action) => {

    let inputZipCodeSelector;
    if (targetID && targetID.indexOf("purchased") !== -1) {
        inputZipCodeSelector = 'label[for="purchasedZip"]';
    }

    if (targetID && targetID.indexOf("purchaser") !== -1) {
        inputZipCodeSelector = 'label[for="purchaserZip"]';
    }

    if (action && action === 'show') {
        document.querySelector(inputZipCodeSelector)?.classList.add('add-bank-loader');
    } else {
        document.querySelector(inputZipCodeSelector)?.classList.remove('add-bank-loader');
    }
}

/**
 * setFormAttributeValue - Method fill City and Sate based on ZipCode Lookup Response
 * @param {*} response 
 * @param {*} targetID 
 */

const setFormAttributeValue = (response, targetID) => {
    try {
        let inputCitySelector;
        let inputStateSelector;

        if (targetID && targetID.indexOf("purchased") !== -1) {
            inputCitySelector = 'input[name="purchasedCity"]';
            inputStateSelector = 'input[name="purchasedState"]';
        }

        if (targetID && targetID.indexOf("purchaser") !== -1) {
            inputCitySelector = 'input[name="purchaserCity"]';
            inputStateSelector = 'input[name="purchaserState"]';
        }

        let inputCityElm = document.querySelector(inputCitySelector);
        let inputStateElm = document.querySelector(inputStateSelector);

        if (response && response.cityStateInfoList && response.cityStateInfoList.cityStateInfo) {

            let cityName = response['cityStateInfoList']['cityStateInfo'][0]['city'];
            let stateName = response['cityStateInfoList']['cityStateInfo'][0]['state'];
            let stateCode = response['cityStateInfoList']['cityStateInfo'][0]['stateCode'];
            cityName = (cityName) ? capitalizeWords(cityName) : cityName;
            stateName = (stateName) ? capitalizeWords(stateName) : stateName;

            if (inputCityElm && inputStateElm) {
                inputCityElm.value = cityName;
                inputStateElm.value = stateName;
                inputStateElm.setAttribute("data-value", stateName);
                inputStateElm.setAttribute("data-keyvalue", stateCode);
            }
        }
    } catch (error) {
        console.log(`${error.message} on set form attribute value  !!`);
        toggleInlineAutoLoader(targetID, 'hide');
    }
}



/**
 * invokeLookUpAPI - Method fetch api
 * @param {*} ZipCode 
 * @returns API Response
 */
const invokeLookUpAPI = (ZipCode, targetID) => {
    try {
        invokeDigitalSession().then((response) => {
            let sessionID = response?.security?.session.id;
            setCookieOnCreateSessionResponse(response);
            if (sessionID) {
                invokeRetailSession(sessionID).then((retailSessionResponse) => {
                    let retailSessionID = retailSessionResponse?.security?.session?.id;
                    if (retailSessionID) {
                        invokeZipcodeLookUp(retailSessionID, ZipCode).then((zipCodeApiResponse) => {
                            if (zipCodeApiResponse && !zipCodeApiResponse.error) {
                                toggleInlineAutoLoader(targetID, 'hide');
                                setFormAttributeValue(zipCodeApiResponse, targetID);
                            } else {
                                toggleInlineAutoLoader(targetID, 'hide');
                            }
                        }).catch((error) => {
                            console.error(error);
                            toggleInlineAutoLoader(targetID, 'hide');
                        });
                    }

                }).catch((error) => {
                    console.error(error);
                });
            }
        }).catch((error) => {
            console.error(error);
        });

    } catch (error) {
        console.error(`Error on fetching API : ${error.message}`);
        toggleInlineAutoLoader(targetID, 'hide');
    }
}

/**
 * FocusOutEventHandler - Method Called on Event Listener
 * @param {*} event 
 * @returns 
 */

const focusOutEventHandler = (event) => {
    try {
        let
            targetID = event?.target?.id,
            zipcode = event?.target?.value;
        if (!zipcode || zipcode.length === 0 || zipcode === '') {
            return false;
        }
        toggleInlineAutoLoader(targetID, 'show');
        invokeLookUpAPI(zipcode, targetID);
    } catch (error) {
        toggleInlineAutoLoader(targetID, 'hide');
    }
}

/* addEventListener - focusout : Selector id = purchasedZip */
if (purchasedZipCodeElement) {
    purchasedZipCodeElement?.addEventListener("blur", focusOutEventHandler);
}
/* addEventListener - focusout : Selector id = purchaserZip */
if (purchaserZipCodeElement) {
    purchaserZipCodeElement?.addEventListener("blur", focusOutEventHandler);
}